import { FormFieldModel } from '../../../Common/PageBuilder/models/form-field.model';
import { AbstractFormFieldComponent } from '../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';

export class BriefingSortByFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    allowAutomaticallyGenerate: boolean;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        allowAutomaticallyGenerate?: boolean
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.allowAutomaticallyGenerate = allowAutomaticallyGenerate;
    }
}
